import type { KeyboardCoordinateGetter } from '@dnd-kit/core';
import { KeyboardCode } from '@dnd-kit/core';

// dnd-kit's own sortable coordinate getter has no notion of rows or columns.
// This utility helps solve that and move images across the grid effectively.
const gridKeyboardCoordinates =
  (getColumns: () => number): KeyboardCoordinateGetter =>
  (event, { context: { active, over, droppableRects } }) => {
    const sortable = active?.data.current?.sortable;

    if (!sortable) {
      return undefined;
    }

    const columns = Math.max(getColumns(), 1);
    const deltas: Record<string, number> = {
      [KeyboardCode.Right]: 1,
      [KeyboardCode.Left]: -1,
      [KeyboardCode.Down]: columns,
      [KeyboardCode.Up]: -columns,
    };
    const delta = deltas[event.code];

    if (delta === undefined) {
      return undefined;
    }

    event.preventDefault();

    const { items } = sortable;
    const overIndex = over ? items.indexOf(String(over.id)) : -1;
    const currentIndex = overIndex === -1 ? sortable.index : overIndex;
    const targetIndex = Math.min(Math.max(currentIndex + delta, 0), items.length - 1);

    if (targetIndex === currentIndex) {
      return undefined;
    }

    const rect = droppableRects.get(items[targetIndex]);

    return rect ? { x: rect.left, y: rect.top } : undefined;
  };

export default gridKeyboardCoordinates;
